<template>
  <div id="app">
    <TopBar />
    <NavBar />
    <router-view></router-view>

    <footer class="site-footer">
      <div class="footer-content">
        <div class="footer-section social-media">
          <a
            class="footer-section__insta"
            href="https://www.instagram.com/harry_beckwith_gardens/"
            target="_blank"
            aria-label="Follow us on Instagram"
          >
            <svg
              class="instagram-icon"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 448 512"
            >
              <path
                d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"
              ></path>
            </svg>
          </a>
        </div>

        <div class="footer-section contact-info">
          <a href="tel:07446738376"> 📞 07446 738 376 </a> <br />
          <a href="mailto:harrybeckwithgardens@gmail.com"
            >✉️ harrybeckwithgardens@gmail.com</a
          >
        </div>

        <div class="footer-section copyright">
          &copy; {{ currentYear }} Harry Beckwith Gardens
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import NavBar from './components/NavBar.vue'
import TopBar from './components/TopBar.vue'

export default {
  name: 'App',
  components: {
    NavBar,
    TopBar,
  },

  computed: {
    /**
     * @returns {number} The current four-digit year (e.g., 2025).
     */
    currentYear() {
      return new Date().getFullYear()
    },
  },
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');
body {
  margin: 0;
  background-color: #faf9f6;
  font-family: 'Poppins', sans-serif;
  font-weight: 400;
  font-style: normal;
  color: #444444;
}

html,
body {
  overflow-x: hidden;
}

p {
  font-size: 15px;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

a:link,
a:visited,
a:hover,
a:active {
  color: inherit; /* Or any color, like #333, inherit, etc. */
  text-decoration: none; /* Removes the underline */
}

// SCSS Variables for Footer Styling
$footer-bg: #526b5c; // Dark green footer background
$footer-text: #ffffff; // White text

.site-footer {
  background-color: $footer-bg;
  color: $footer-text;
  padding: 30px 20px;
  font-family: Arial, sans-serif;
  margin-top: 40px; // Space above the footer
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  color: $footer-text;

  // --- Flexbox for layout ---
  display: flex;
  flex-wrap: wrap; // Allows stacking on small screens
  justify-content: space-between; // Pushes content to the edges
  align-items: center;
  text-align: center; // Fallback alignment
}

.footer-section {
  padding: 10px; // Padding around each section

  // Allows sections to grow equally on one line, or take full width on wrap
  flex: 1;
  min-width: 200px; // Minimum width before wrapping

  a {
    color: $footer-text; // Link color is white by default
    text-decoration: none;
    transition: color 0.3s ease;
  }

  .instagram-icon {
    width: 22px; // Large icon size
    fill: white;
  }
}

// Optional: Media Query for Mobile Layout
@media (max-width: 768px) {
  .footer-content {
    flex-direction: column; // Stack items vertically on mobile

    .footer-section {
      width: 100%;
      margin-bottom: 15px; // Add space between stacked items
    }
  }
}
</style>
